import { Util } from 'src/shared/util/util';
import { WindowService } from './../../../shared/providers/window.service';
import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';

type MessageType = 'chat' | 'call' | 'email' | 'proxy' | 'homekeeper_job';

@Component({
    selector: 'tidy-message-card',
    templateUrl: './message-card.html',
    styleUrls: ['./message-card.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})


export class MessageCardComponent implements OnInit {

  @Input() isUnread = false;
  @Input() type: MessageType = 'chat';
  @Input() initials = '';
  @Input() message: any = {};
  @Input() tags: string[] = [];
  @Input() date = '';
  @Input() files: string[] = [];
  @Input() messageCategory: 'pro' | 'guest' | 'unknown' = 'unknown';
  @Input() contactInfo: any = null;
  isDesktopRes = false;
  isUnknownNumber = false;

  // Image preview properties
  showImagePreview = false;
  previewImageSrc = '';

  constructor(public windowService: WindowService, public util: Util) {}

  ngOnInit(): void {
    const validTypes: MessageType[] = ['chat', 'call', 'email', 'proxy', 'homekeeper_job'];
    if (!validTypes.includes(this.type)) {
      this.type = 'chat';
    }
    if (this.windowService.isDesktopRes) {
      this.isDesktopRes = true;
    }
    if (/\d/.test(this.initials)) {
      this.isUnknownNumber = true;
    }
  }

  onMessageCardClick() {
    // Event handler placeholder
  }

  trackByTag(index: number, tag: string): string | number {
    return tag || index;
  }

  openImagePreview(imageSrc: string) {
    this.previewImageSrc = imageSrc;
    this.showImagePreview = true;
  }

  onImagePreviewDismiss() {
    this.showImagePreview = false;
    this.previewImageSrc = '';
  }

  openFile(event: Event, url: string) {
    event.stopPropagation();
    event.preventDefault();
    window.open(url, '_blank');
  }
}
